import React, { useContext } from 'react'
import { productsDataType } from 'models/propTypes'
import ProductItemContainer from 'containers/designSidepanel/ProductItemContainer'
import { FURNITURE_BROWSE_NUM_COLUMNS } from 'models/ui/constants'
import { TRACKING_ADDED_FROM_RECOMMENDED } from 'models/tracking/constants'
import { useTranslation } from 'react-i18next'

import SugarcubeContext from 'apps/SugarcubeContext'

require('./RelatedProducts.scss')

const RelatedProducts = ({ furnituresData }) => {
    const { t } = useTranslation()
    const { isMobile } = useContext(SugarcubeContext)

    if (!furnituresData || !furnituresData.length) {
        return null
    }

    const rowCount = isMobile ? 1 : Math.ceil(furnituresData.length / FURNITURE_BROWSE_NUM_COLUMNS)
    const rowArray = [...Array(rowCount).keys()]
    return (
        <div className="RelatedProducts">
            <div className="title">{t('related.you may also like')}</div>
            <div className="items">
                {rowArray.map((_, index) => {
                    const data1 = furnituresData[2 * index]
                    const data2 = furnituresData[2 * index + 1]
                    return (
                        <div className="furnitureListRow" key={data1.id} data-testid="related-products-row">
                            {data1 && (
                                <ProductItemContainer
                                    furnitureData={data1}
                                    trackingInfoAddedFrom={TRACKING_ADDED_FROM_RECOMMENDED}
                                />
                            )}
                            {data2 && (
                                <ProductItemContainer
                                    furnitureData={data2}
                                    trackingInfoAddedFrom={TRACKING_ADDED_FROM_RECOMMENDED}
                                />
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

RelatedProducts.defaultProps = {
    furnituresData: [],
}
RelatedProducts.propTypes = {
    furnituresData: productsDataType,
}
export default RelatedProducts
